import React from 'react';
import PropTypes from 'prop-types';
import CheckboxColumn from '../CheckboxColumn';
import './LocationCheckboxes.scss';

const LocationCheckboxes = ({
  primary,
  selectedLocations,
  allLocations,
  onCheckboxChange,
  disabled,
}) => {
  const middleIndex = Math.ceil(allLocations.length / 2);
  const leftLocations = allLocations.slice(0, middleIndex);
  const rightLocations = allLocations.slice(middleIndex);
  return (
    <div>
      <CheckboxColumn
        primary={primary}
        className="CheckboxColumn"
        allLocations={leftLocations}
        selectedLocations={selectedLocations}
        onCheckboxChange={onCheckboxChange}
        disabled={disabled}
      />
      <CheckboxColumn
        primary={primary}
        className="CheckboxColumn CheckboxColumn-col2"
        allLocations={rightLocations}
        selectedLocations={selectedLocations}
        onCheckboxChange={onCheckboxChange}
        disabled={disabled}
      />
    </div>
  );
};

LocationCheckboxes.propTypes = {
  primary: PropTypes.string,
  allLocations: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  selectedLocations: PropTypes.shape({}),
  onCheckboxChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

LocationCheckboxes.defaultProps = {
  primary: PropTypes.string,
  allLocations: [],
  selectedLocations: {},
  disabled: false,
};

export default LocationCheckboxes;
